import { memo, useCallback } from "react";
import TooltipHelper from "components/TooltipHelper";
import IconButton from "@mui/material/IconButton";
import { useTranslation } from "react-i18next";
import useBoolean from "hooks/useBoolean";
import ThemeProvider2024 from "components/MuiThemeProvider/ThemeProvider2024";
import AthleteBulkDeleteControlDialog from "./AthleteBulkDeleteControlDialog";
import useAthleteActions from "providers/AthletesProvider/useAthleteActions";
import { useRequest } from "hooks";
import TrashIcon from "components/Icons/TrashIcon";

interface AthleteBulkDeleteControlProps {
  ids: string[];
}

function AthleteBulkDeleteControl(props: AthleteBulkDeleteControlProps) {
  const { ids } = props;
  const { value: open, setFalse, setTrue } = useBoolean();
  const { t } = useTranslation();

  const athleteActions = useAthleteActions();
  const onDelete = useRequest(athleteActions.delete);

  const handleDelete = useCallback(async () => {
    await Promise.all(ids.map((id) => onDelete(id)));
    setFalse();
  }, [onDelete, setFalse, ids]);

  return (
    <ThemeProvider2024>
      <TooltipHelper title={t("athlete.bulk_delete_athlete_button_text")} placement="top">
        <span>
          <IconButton
            color="primary"
            size="small"
            onClick={setTrue}
            disabled={!ids.length}
            aria-label={t("athlete.bulk_delete_athletes_aria_label")}
          >
            <TrashIcon />
          </IconButton>
        </span>
      </TooltipHelper>

      <AthleteBulkDeleteControlDialog open={open} ids={ids} onClose={setFalse} onDelete={handleDelete} />
    </ThemeProvider2024>
  );
}

export default memo(AthleteBulkDeleteControl);
